/* @ngInject */
const areaIcons = () => {
  const self = {}

  self.name = 'aspect_ratio'
  self.isReal = 'aspect_ratio'

  return self
}

export default areaIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/resources/icons.resource.js